import { useEffect, useState } from 'react';
import { Card, Skeleton, Text, styled } from '@/theme/index';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  boxShadow: 'none',
  border: `1px solid ${theme.palette.primary.main}`,
  margin: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(2, 0),
  },
}));

const idsToCheck = [
  'relatives-section',
  'life-events-section',
  'personal-interest-section',
  'funeral-details-section',
];

export function ObituarySmartInsight({ isLoading }: { isLoading: boolean }) {
  const [existSmartInsight, setExistSmartInsight] = useState<boolean>(false);

  // This useEffect will check if the sections below exist in the DOM, this to avoid using a lot of conditions to check if it exists
  useEffect(() => {
    const loadData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      for (const id of idsToCheck) {
        const element = document.getElementById(id);
        if (element) {
          setExistSmartInsight(true);
          return;
        }
      }
    };

    if (!isLoading) loadData();
  }, [isLoading]);

  if (isLoading)
    return (
      <Card sx={{ boxShadow: 'none' }}>
        <Skeleton variant="rounded" width="100%" height={35} />
      </Card>
    );

  if (!existSmartInsight) return null;

  return (
    <StyledCard data-cy="obituary-smart-insight">
      <Text typography="body1">
        The sections below contain data derived by our Smart Insight AI from the
        raw obituary above. Some of the information may be inaccurate or
        misallocated.
      </Text>
    </StyledCard>
  );
}
